(function () {
  var HIDDEN_CLASS = 'variant-media-hidden';

  function normalizeColor(str) {
    return (str || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function setVisible(el, show) {
    el.classList.toggle(HIDDEN_CLASS, !show);
    if (show) {
      el.classList.remove('d-none', 'd-none-important');
      el.removeAttribute('hidden');
      el.setAttribute('aria-hidden', 'false');
    } else {
      el.setAttribute('hidden', '');
      el.setAttribute('aria-hidden', 'true');
    }
  }

  function getColorMap(sectionId) {
    var el = document.getElementById('ProductMediaColors-' + sectionId);
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return {};
    }
  }

  function getMediaIdFromEl(el) {
    if (!el) return null;
    return el.dataset.shopifyMediaId || el.dataset.mediaId || el.dataset.mediaTargetId || null;
  }

  function getVariantPicker(sectionId) {
    return document.querySelector(
      'sht-variant-radios[data-section="' + sectionId + '"], sht-variant-selects[data-section="' + sectionId + '"]'
    );
  }

  function getVariants(picker) {
    if (!picker) return [];
    var jsonEl = picker.querySelector('[type="application/json"]');
    if (!jsonEl) return [];
    try {
      return JSON.parse(jsonEl.textContent);
    } catch (e) {
      return [];
    }
  }

  function getCurrentVariant(sectionId, picker) {
    var variants = getVariants(picker);
    if (!variants.length) return null;

    var form = document.getElementById('productForm-' + sectionId);
    var idInput = form && form.querySelector('[name="id"]');
    if (idInput && idInput.value) {
      var byId = variants.find(function (v) {
        return String(v.id) === String(idInput.value);
      });
      if (byId) return byId;
    }

    var selectedOptions = [];
    picker.querySelectorAll('.js-variant-radio-container').forEach(function (container) {
      var indexEl = container.querySelector('[data-option-index]');
      var index = indexEl ? parseInt(indexEl.dataset.optionIndex, 10) : selectedOptions.length;
      var checked = container.querySelector('input:checked');
      if (checked) selectedOptions[index] = checked.value;
    });

    if (picker.tagName === 'SHT-VARIANT-SELECTS') {
      selectedOptions = [];
      picker.querySelectorAll('.js-variant-select-item').forEach(function (select, i) {
        selectedOptions[i] = select.value;
      });
    }

    return variants.find(function (v) {
      return v.options.every(function (opt, i) {
        return selectedOptions[i] === undefined || opt === selectedOptions[i];
      });
    });
  }

  function getMediaOrder(sectionId) {
    var slideshow = document.querySelector('sht-prd-slideshow[data-section="' + sectionId + '"]');
    if (!slideshow) return [];

    var seen = {};
    var order = [];

    slideshow.querySelectorAll('.js-product-slideshow-item').forEach(function (item) {
      var id = getMediaIdFromEl(item);
      if (id && !seen[id]) {
        seen[id] = true;
        order.push(String(id));
      }
    });

    return order;
  }

  function getFeaturedColorForMedia(mediaId, variants, colorOptionIndex) {
    var owner = variants.find(function (v) {
      return v.featured_media && String(v.featured_media.id) === String(mediaId);
    });
    return owner ? owner.options[colorOptionIndex] : null;
  }

  function getFeaturedIndexForColor(color, variants, colorOptionIndex, mediaOrder, preferredMediaId) {
    var normalized = normalizeColor(color);
    var indices = [];

    if (preferredMediaId) {
      var preferredIdx = mediaOrder.indexOf(String(preferredMediaId));
      if (preferredIdx !== -1) return preferredIdx;
    }

    mediaOrder.forEach(function (mediaId, index) {
      var featuredColor = getFeaturedColorForMedia(mediaId, variants, colorOptionIndex);
      if (featuredColor && normalizeColor(featuredColor) === normalized) {
        indices.push(index);
      }
    });

    return indices.length ? Math.min.apply(null, indices) : -1;
  }

  function getColorValuesFromVariants(variants, colorOptionIndex) {
    var values = [];
    variants.forEach(function (v) {
      var c = v.options[colorOptionIndex];
      if (c && values.indexOf(c) === -1) values.push(c);
    });
    return values.sort(function (a, b) {
      return b.length - a.length;
    });
  }

  function getColorFromDomMedia(mediaId, sectionId, colorValues) {
    var el = document.querySelector(
      'sht-prd-slideshow[data-section="' + sectionId + '"] [data-shopify-media-id="' + mediaId + '"]'
    );
    var img = el && el.querySelector('img');
    if (!img || !img.alt) return null;
    var alt = normalizeColor(img.alt);
    for (var i = 0; i < colorValues.length; i++) {
      var val = normalizeColor(colorValues[i]);
      if (alt === val || alt.indexOf(val) !== -1) return colorValues[i];
    }
    return null;
  }

  function getAllowedMediaIds(sectionId, variants, colorOptionIndex, selectedColor, preferredMediaId, colorMap) {
    var mediaOrder = getMediaOrder(sectionId);
    if (!mediaOrder.length) return null;

    var colorValues = getColorValuesFromVariants(variants, colorOptionIndex);
    var normalizedSelected = normalizeColor(selectedColor);
    var allowed = new Set();

    mediaOrder.forEach(function (mediaId) {
      var featuredColor = getFeaturedColorForMedia(mediaId, variants, colorOptionIndex);
      var domColor = getColorFromDomMedia(mediaId, sectionId, colorValues);
      var mapped = colorMap[mediaId];

      var matchesSelected =
        (featuredColor && normalizeColor(featuredColor) === normalizedSelected) ||
        (domColor && normalizeColor(domColor) === normalizedSelected) ||
        (mapped && normalizeColor(mapped) === normalizedSelected);

      if (matchesSelected) {
        allowed.add(String(mediaId));
      }
    });

    return allowed.size ? allowed : null;
  }

  function filterVariantMedia(sectionId) {
    var slideshow = document.querySelector('sht-prd-slideshow[data-section="' + sectionId + '"]');
    if (!slideshow) return;

    var colorOptionIndex = parseInt(slideshow.dataset.colorOptionIndex, 10);
    if (isNaN(colorOptionIndex) || colorOptionIndex < 0) return;

    var colorMap = getColorMap(sectionId);
    var picker = getVariantPicker(sectionId);
    var variant = getCurrentVariant(sectionId, picker);
    if (!variant || !variant.options[colorOptionIndex]) return;

    var variants = getVariants(picker);
    var selectedColorRaw = variant.options[colorOptionIndex];
    var normalizedSelected = normalizeColor(selectedColorRaw);
    var hideVariant = slideshow.dataset.hideVariantImage === 'true';
    var isMobile = window.matchMedia('(max-width: 768px)').matches;
    var preferredMediaId = variant.featured_media ? String(variant.featured_media.id) : null;

    var allowedIds = getAllowedMediaIds(
      sectionId,
      variants,
      colorOptionIndex,
      selectedColorRaw,
      preferredMediaId,
      colorMap
    );

    function matches(mediaId) {
      if (!mediaId) return false;
      if (allowedIds) return allowedIds.has(String(mediaId));

      var mapped = colorMap[mediaId];
      if (!mapped) return true;
      return normalizeColor(mapped) === normalizedSelected;
    }

    var visibleThumbs = [];
    slideshow.querySelectorAll('.js-product-slideshow-thumb, .js-gallery-thumb').forEach(function (thumb) {
      var show = matches(getMediaIdFromEl(thumb));
      setVisible(thumb, show);
      if (!show) thumb.classList.remove('is-active-item');
      if (show) visibleThumbs.push(thumb);
    });

    var visibleItems = [];
    slideshow.querySelectorAll('.js-product-slideshow-item').forEach(function (item) {
      if (matches(getMediaIdFromEl(item))) visibleItems.push(item);
    });

    if (!visibleItems.length) {
      slideshow.querySelectorAll('.js-product-slideshow-thumb, .js-gallery-thumb, .js-product-slideshow-item').forEach(function (el) {
        setVisible(el, true);
      });
      filterDialogMedia(sectionId, matches, preferredMediaId);
      return;
    }

    slideshow.querySelectorAll('.js-product-slideshow-item').forEach(function (item) {
      var show = visibleItems.indexOf(item) !== -1;
      if (!show) {
        setVisible(item, false);
        item.classList.remove('d-block');
        return;
      }

      setVisible(item, true);

      if (hideVariant && !isMobile) {
        item.classList.add('d-none');
        item.classList.remove('d-block');
      } else {
        item.classList.remove('d-none');
      }
    });

    if (hideVariant && !isMobile) {
      var activeItem =
        visibleItems.find(function (item) {
          return getMediaIdFromEl(item) === preferredMediaId;
        }) || visibleItems[0];
      setVisible(activeItem, true);
      activeItem.classList.remove('d-none');
      activeItem.classList.add('d-block');
      preferredMediaId = getMediaIdFromEl(activeItem);
    }

    slideshow.querySelectorAll('.js-product-slideshow-thumb, .js-gallery-thumb').forEach(function (thumb) {
      thumb.classList.remove('is-active-item');
    });

    var activeThumb = visibleThumbs.find(function (thumb) {
      return getMediaIdFromEl(thumb) === preferredMediaId;
    }) || visibleThumbs[0];

    if (activeThumb) {
      activeThumb.classList.add('is-active-item');
      var vertCarousel = slideshow.querySelector('sht-vert-carousel .js-carousel-items');
      if (vertCarousel) {
        vertCarousel.scrollTo({ top: 0, behavior: 'auto' });
      }
      var horizCarousel = slideshow.querySelector('sht-horizoltal-carousel .js-carousel-items');
      if (horizCarousel) {
        horizCarousel.scrollTo({ left: activeThumb.offsetLeft, behavior: 'auto' });
      }
    }

    if (isMobile && preferredMediaId) {
      var carousel = document.querySelector('sht-carousel[data-section-id="' + sectionId + '"]');
      var activeSlide = visibleItems.find(function (item) {
        return getMediaIdFromEl(item) === preferredMediaId;
      });
      if (carousel && activeSlide) {
        carousel.querySelector('.js-carousel-items').scrollTo({ left: activeSlide.offsetLeft, behavior: 'smooth' });
      }
    }

    filterDialogMedia(sectionId, matches, preferredMediaId);

    var counter = slideshow.querySelector('.js-carousel-counter-total');
    if (counter) counter.textContent = visibleItems.length;
  }

  function bindFilterEvents(sectionId) {
    var picker = getVariantPicker(sectionId);
    var run = function () {
      setTimeout(function () {
        filterVariantMedia(sectionId);
      }, 50);
    };

    if (picker) {
      picker.addEventListener('change', run);
    }

    var form = document.getElementById('productForm-' + sectionId);
    var idInput = form && form.querySelector('[name="id"]');
    if (idInput) {
      idInput.addEventListener('change', run);
    }

    document.querySelectorAll('.color-image-picker').forEach(function (pickerEl) {
      pickerEl.addEventListener('change', run);
    });
  }

  function initSection(slideshow) {
    var sectionId = slideshow.dataset.section;
    bindFilterEvents(sectionId);
    setTimeout(function () {
      filterVariantMedia(sectionId);
    }, 50);
  }

  function init() {
    document.querySelectorAll('sht-prd-slideshow[data-color-option-index]').forEach(initSection);
  }

  if (typeof SHTDefer !== 'undefined') {
    SHTDefer.push(init);
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();